function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 7V25",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 20.8988C2.99996 20.6684 3.07957 20.4451 3.22536 20.2667C3.37114 20.0883 3.57412 19.9658 3.7999 19.92C4.70332 19.7354 5.51527 19.2445 6.09839 18.5302C6.68151 17.8159 7 16.9221 7 16C7 15.0779 6.68151 14.1841 6.09839 13.4698C5.51527 12.7555 4.70332 12.2646 3.7999 12.08C3.57412 12.0342 3.37114 11.9117 3.22536 11.7333C3.07957 11.5549 2.99996 11.3316 3 11.1012V8C3 7.73478 3.10536 7.48043 3.29289 7.29289C3.48043 7.10536 3.73478 7 4 7H28C28.2652 7 28.5196 7.10536 28.7071 7.29289C28.8946 7.48043 29 7.73478 29 8V11.1012C29 11.3316 28.9204 11.5549 28.7746 11.7333C28.6289 11.9117 28.4259 12.0342 28.2001 12.08C27.2967 12.2646 26.4847 12.7555 25.9016 13.4698C25.3185 14.1841 25 15.0779 25 16C25 16.9221 25.3185 17.8159 25.9016 18.5302C26.4847 19.2445 27.2967 19.7354 28.2001 19.92C28.4259 19.9658 28.6289 20.0883 28.7746 20.2667C28.9204 20.4451 29 20.6684 29 20.8988V24C29 24.2652 28.8946 24.5196 28.7071 24.7071C28.5196 24.8946 28.2652 25 28 25H4C3.73478 25 3.48043 24.8946 3.29289 24.7071C3.10536 24.5196 3 24.2652 3 24V20.8988Z",
  stroke: "#FBFBFB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTicket = function SvgTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ticket.317e6d2f.svg";
export { ForwardRef as ReactComponent };